
define( 'FORCES_AND_MOTION_BASICS/../nls/de/forces-and-motion-basics-strings',{
          "none": "keine",
          "force": "Kraft",
          "values": "Werte",
          "frictionTitle": "Reibung",
          "redWins": "Rot gewinnt!",
          "frictionForce": "Reibungskraft",
          "pause": "Pause",
          "friction": "Reibung",
          "accelerationLab": "Beschleunigungslabor",
          "forces-and-motion-basics.name": "Kräfte und Bewegung: Grundlagen",
          "appliedForce": "ausgeübte Kraft",
          "leftForce": "Kraft nach links",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Kraft nach rechts",
          "acceleration": "Beschleunigung",
          "sound": "Ton",
          "lots": "viel",
          "forces": "Kräfte",
          "motion": "Bewegung",
          "tugOfWar": "Tauziehen",
          "go": "Start",
          "newtons.n": "Newton (N)",
          "sumOfForcesEqualsZero": "Kräftesumme = 0",
          "blueWins": "Blau gewinnt!",
          "speed": "Geschwindigkeit",
          "sumOfForces": "Kräftesumme",
          "return": "Zurück",
          "translation.credits": "Michael Becker",
          "newtons": "Newton",
          "masses": "Massen",
          "forceReadout.pattern": "{0} N"
        } );